<template>
  <div>
    <img :src="`${imgPath}/titles/${titlePath}`" />
  </div>
</template>

<script>
export default {
  props: {
    titlePath: String,
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
};
</script>

<style></style>
